// import React, { createContext, useState, useEffect } from "react";
// import Cookies from "js-cookie";
// import { jwtDecode } from "jwt-decode";
// import { redirect, useNavigate } from "react-router-dom";
// import LoadingScreen from "../Components/LoadingScreen";

// export const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [token, setToken] = useState(null);
//   const [allowedModules, setAllowedModules] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const checkToken = () => {
//       const storedToken = Cookies.get("authToken");
//       if (!storedToken) {
//         sessionStorage.removeItem("expired_notified");
//         navigate("/signin", { replace: true });
//         setLoading(false);
//         return;
//       }

//       try {
//         const decoded = jwtDecode(storedToken);
//         if (decoded.exp * 1000 > Date.now()) {
//           const userInfo = {
//             name: decoded.name || decoded.full_name || decoded.username || null,
//             email: decoded.email || null,
//             role: decoded.role || decoded.roles || null,
//             property_name: decoded.property_id || null,
//             property_code:
//               decoded.property_code || decoded.propertyCode || null,
//           };
//           setUser(userInfo);
//           setToken(storedToken);
//           setAllowedModules(decoded.modules || []);
//           const modules = decoded.modules || [];
//           const currentPath = window.location.pathname;

//           if (currentPath === "/" || currentPath === "/signin") {
//             if (modules.includes("pms")) navigate("/index", { replace: true });
//             else if (modules.includes("hrms"))
//               navigate("/hrms-dashboard", { replace: true });
//             else if (modules.includes("ADMIN"))
//               navigate("/index-admin", { replace: true });
//           }
//         } else {
//           Cookies.remove("authToken");
//         }
//       } catch {
//         Cookies.remove("authToken");
//       }
//       setLoading(false);
//     };

//     checkToken();
//   }, []);

//   const login = (jwtToken) => {
//     Cookies.set("authToken", jwtToken);
//     sessionStorage.removeItem("expired_notified");
//     const decoded = jwtDecode(jwtToken);
//     const userInfo = {
//       name: decoded.name || decoded.full_name || decoded.username || null,
//       email: decoded.email || null,
//       role: decoded.role || decoded.roles || null,
//       property_name: decoded.property_id || null,
//       property_code: decoded.property_code || decoded.propertyCode || null,
//     };
//     setUser(userInfo);
//     setToken(jwtToken);
//     setAllowedModules(decoded.modules || []);
//     const modules = decoded.modules || [];
//     let redirectPath = "/signin";
//     if (modules.includes("pms")) redirectPath = "/index";
//     else if (modules.includes("hrms")) redirectPath = "/hrms-dashboard";
//     navigate(redirect, { replace: true });
//   };

//   const logout = () => {
//     Cookies.remove("authToken");
//     setUser(null);
//     setToken(null);
//     setAllowedModules([]);
//     navigate("/signin");
//   };

//   if (loading) return <LoadingScreen />;

//   return (
//     <AuthContext.Provider
//       value={{ user, token, allowedModules, login, logout, loading }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };


import React, { createContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "../Components/LoadingScreen";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [allowedModules, setAllowedModules] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const checkToken = () => {
      const storedToken = Cookies.get("authToken");

      if (!storedToken) {
        navigate("/signin", { replace: true });
        setLoading(false);
        return;
      }

      try {
        const decoded = jwtDecode(storedToken);

        if (decoded.exp * 1000 < Date.now()) {
          Cookies.remove("authToken");
          navigate("/signin", { replace: true });
        } else {
          const userInfo = {
            name: decoded.name || decoded.username || null,
            email: decoded.email || null,
            role: decoded.role || null,
            property_name: decoded.property_id || null,
            property_code: decoded.property_code || null,
          };

          setUser(userInfo);
          setToken(storedToken);
          setAllowedModules(decoded.modules || []);

          // Auto redirect on refresh
          const modules = decoded.modules || [];
          const path = window.location.pathname;

          if (path === "/" || path === "/signin") {
            if (modules.includes("pms")) navigate("/index", { replace: true });
            else if (modules.includes("hrms"))
              navigate("/hrms-dashboard", { replace: true });
          }
        }
      } catch (_) {
        Cookies.remove("authToken");
        navigate("/signin", { replace: true });
      }

      setLoading(false);
    };

    checkToken();
  }, []);

  const login = (jwtToken) => {
    Cookies.set("authToken", jwtToken);

    const decoded = jwtDecode(jwtToken);

    const userInfo = {
      name: decoded.name || decoded.username || null,
      email: decoded.email || null,
      role: decoded.role || null,
      property_name: decoded.property_id || null,
      property_code: decoded.property_code || null,
    };

    setUser(userInfo);
    setToken(jwtToken);
    setAllowedModules(decoded.modules || []);

    const modules = decoded.modules || [];
    if (modules.includes("pms")) navigate("/index", { replace: true });
    else if (modules.includes("hrms"))
      navigate("/hrms-dashboard", { replace: true });
    else navigate("/signin", { replace: true });
  };

  const logout = () => {
    Cookies.remove("authToken");
    setUser(null);
    setToken(null);
    setAllowedModules([]);
    navigate("/signin", { replace: true });
  };

  if (loading) return <LoadingScreen />;

  return (
    <AuthContext.Provider
      value={{ user, token, allowedModules, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
